import React, {useContext, useRef} from "react";
import cx from 'classnames';
import {Button, Col, Row, Space} from "antd";
import {useRouter} from "next/router";
import {useSize} from "ahooks";
import styles from "@/page-components/detail/Intro/styles.module.less";
import IntroComponent from "@/page-components/detail/Intro/intro_component";
import PCSignupBtn from "@/page-components/detail/Intro/pc_signup_btn";
import ExamPlan, {PayState} from "@/page-components/detail/Intro/exam_plan";
import SignupInfo from "@/page-components/detail/Intro/signup_info";
import FastNav from "@/page-components/detail/Fast_nav";
import {Media} from "@/constants/media_query";
import {DetailContext} from "@/context/detailContext";
import HistoryPass from "@/page-components/detail/Intro/historyPass";
import {checkHtml} from "@/utils/index";
import BatchList from "@/page-components/detail/BatchList/index";


const IntroPC: React.FC = () => {
  const contextProps = useContext(DetailContext);
  const {signupInfo, data, isHistoryPass, userInfo} = contextProps;
  const {type, leftNavs} = data;
  const {isOrganizationAdmin} = userInfo;
  const info = data.exam_info;
  const router = useRouter();
  const isRenderCom = (isJudgeLeida: boolean = false) => {
    if (isJudgeLeida) {
      if (isHistoryPass) {
        return false;
      }
      // 报名信息为空或者报名信息里有未付款
      if (signupInfo && Array.isArray(signupInfo) && signupInfo.length !== 0) {
        // eslint-disable-next-line no-plusplus
        for (let i = 0; i < signupInfo.length; i++) {
          const signupInfoItem = signupInfo[i];
          if (signupInfoItem.payState === undefined) {
            return false
          }
          return (signupInfoItem.payState === PayState.payed);
        }
      }
      return false;
    }
    if (isHistoryPass) {
      return true;
    }
    // 报名信息为空或者报名信息里有未付款
    if (signupInfo && Array.isArray(signupInfo) && signupInfo.length !== 0) {
      // eslint-disable-next-line no-plusplus
      for (let i = 0; i < signupInfo.length; i++) {
        const signupInfoItem = signupInfo[i];
        if (signupInfoItem.payState === undefined) {
          return false
        }
        return (signupInfoItem.payState === PayState.payed);
      }
    }
    return false;

  }
  const ref = useRef(null);
  const size = useSize(ref);
  const left = size ? (size.width - 1440) / 2 : 0;
  return (
    <Row className={styles.intro_wrapper} ref={ref}>
      {data.exam_info && (
        <div className={styles.intro}>
          <Col className={cx(styles.item, styles.flex_item)} span={8}>
            {isRenderCom() ? (
              <>
                {isHistoryPass ? (
                  <HistoryPass
                    isOrganizationAdmin={isOrganizationAdmin}
                    type={type}
                    pass_tips={info.pass_tips}
                    pass_link={info.pass_link}
                  />) : (
                  <>
                    <SignupInfo
                      type={type}
                      allData={signupInfo}
                      data={signupInfo[0]}
                    />
                  </>
                )}
              </>
            ) : (
              <>
                <div style={{flex: 1}}>
                  <div className={styles.title}>报考说明</div>
                  <div className={styles.row}>
                    <Space size={4}>
                      <p className={styles.subtitle}>报考要求:</p>
                      {checkHtml(info?.require) ? <div className={cx(styles.link, styles.subtitle_text)}
                                                       dangerouslySetInnerHTML={{__html: info?.require}}/> : (
                        <div className={styles.subtitle_text}>{info?.require}</div>
                      )}
                    </Space>
                  </div>
                  <div className={styles.row}>
                    <Space size={4}>
                      <p className={styles.subtitle}>考试时长:</p>
                      <p className={styles.subtitle_text}>
                        <BatchList/>
                      </p>
                    </Space>
                  </div>
                  <div className={styles.row}>
                    <Space size={4}>
                      <p className={styles.subtitle}>报考费用:</p>
                      <p
                        className={styles.subtitle_text}>{info?.exam_money === 0 ? '免费' : `${info?.exam_money}元`}</p>
                    </Space>
                  </div>
                  {info?.subjects && (
                    <div className={styles.row}>
                      <Space align="start" size={4}>
                        <p className={styles.subtitle}>考试科目：</p>
                        <div>
                          {info?.subjects.map((item, index) => {
                            return (
                              <div key={item.label}>
                                <Space size={4}>
                                  <p className={styles.subtitle_text}>{item.label}</p>
                                  <p className={styles.subtitle_text_score_text}>{item.price}元</p>
                                </Space>
                              </div>
                            )
                          })}
                        </div>
                      </Space>
                    </div>
                  )}
                  {info.extra_tips && info.extra_tips.map(extra => {
                    return (
                      <div className={styles.row}>
                        <Space size={4}>
                          <p className={styles.subtitle}>{extra.label}:</p>
                          <p className={styles.subtitle_text}>{extra.value}</p>
                        </Space>
                      </div>
                    )
                  })}
                  <div className={styles.row}>
                    <Space size={4} align="start">
                      <p className={styles.subtitle}>通过条件:</p>
                      <p className={styles.subtitle_text}>{info?.pass_condition}</p>
                    </Space>
                  </div>
                </div>
                <Row gutter={16} className={styles.btn_row}>
                  <Col span={12}>
                    <PCSignupBtn
                      payState={signupInfo.length > 0 ? signupInfo[0].payState : undefined}
                    />
                  </Col>
                  <Col span={12}>
                    <Button className={styles.simple_btn} onClick={() => {
                      router.push('/verify')
                    }}>证书&成绩查询</Button>
                  </Col>
                </Row>
              </>
            )}
          </Col>
          <Col className={styles.item} span={8}>
            {isRenderCom(true) ? <ExamPlan type={type} data={signupInfo}/> : (
              <>
                <p className={styles.title}>能力雷达</p>
                <div className={styles.leida_img_wrapper}>
                  <img src={info.leida_url} alt="" className={styles.leida_img}/>
                </div>
              </>
            )}
          </Col>
          <Col span={8} className={cx(styles.item, styles.last_item)}>
            {leftNavs.map((item, index) => {
              return (
                <IntroComponent
                  key={String(Math.random())}
                  href={item.href}
                  icon={`/img/detail/nav_icon${index + 1}.png`}
                  title={item.label}
                  english_title={item.english_label}
                />
              )
            })}
          </Col>
        </div>
      )}
      <Media greaterThanOrEqual="xl">
        <FastNav left={left}/>
      </Media>
    </Row>
  )
}
export default IntroPC;
